import React from "react";
import { useTheme } from "styled-components";

import { Icon, style } from "./Symbolicons";

const MoneyBanknote = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M14.667 21.2H5.2a2.532 2.532 0 0 1-2.533-2.533V6.533C2.667 5.133 3.8 4 5.2 4h20.267C26.867 4 28 5.133 28 6.533v6.8"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.572 10.628a3.168 3.168 0 0 1 0 4.479 3.168 3.168 0 0 1-4.479 0 3.166 3.166 0 1 1 4.479-4.479"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M29.333 22.667A5.325 5.325 0 0 1 24 28a5.325 5.325 0 0 1-5.333-5.333A5.325 5.325 0 0 1 24 17.333a5.325 5.325 0 0 1 5.333 5.334Z"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17.333H6.667M24 8h-1.333M20.23 26.436l7.54-7.54"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { MoneyBanknote };
